"use client";
import * as React from "react";
const SvgWarningOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8 3 5.48 9.45H2.52zM8 .08 0 13.91h16zm.73 10.18H7.27v1.46h1.46zm0-4.36H7.27v2.9h1.46z" }));
export {
  SvgWarningOutlined as default
};
